import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import { showMessage, openLoaderWithMessage, closeLoaderWithMessage } from "../messages/messagesActions";
import { IPAInsurance } from "./paInsurance.types";

export const getPAInsuranceListAsync =
  (
    urlParams: string,
    onCallback: (isSuccess: boolean, data?: IPAInsurance[], totalRecords?: number) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const finalUrl = `/partner/get-pa-insurance${urlParams ? `?${urlParams}` : ''}`;
      const res = await api.get(finalUrl);
      
      const data = res?.data?.data || [];
      const totalRecords = res?.data?.total_records || res?.data?.totalRecords || 0;
      
      onCallback(true, data, totalRecords);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err?.response?.data?.message || "Failed to fetch PA Insurance list",
          displayAs: "snackbar",
        })
      );
    }
  };

export const downloadPolicyDocAsync =
  (
    membershipCode: string,
    onCallback?: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(openLoaderWithMessage("Downloading policy document, please wait..."));
      const url = `/partner/download-policy-doc?membership_code=${membershipCode}`;
      
      const res = await api.get(url, {
        responseType: "blob",
      });
      
      let fileName = `${membershipCode}_policy.pdf`;
      const contentDisposition = res.headers["content-disposition"];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }
      
      const blob = new Blob([res.data], { type: res.data.type || "application/pdf" });
      const urlObject = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlObject;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      
      window.URL.revokeObjectURL(urlObject);
      document.body.removeChild(link);
      
      dispatch(
        showMessage({
          message: "Policy document downloaded successfully",
          type: "success",
          displayAs: "snackbar",
        })
      );
      if (onCallback) {
        onCallback(true);
      }
    } catch (err: any) {
      dispatch(
        showMessage({
          message: err?.response?.data?.message || "Failed to download policy document",
          type: "error",
          displayAs: "snackbar",
        })
      );
      if (onCallback) {
        onCallback(false);
      }
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

